import type { EnrichedGlobalPcSet } from '../../model/types'

import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useUpdateGlobalPcSetMutation } from '@/entities/pricing-campaign'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'
import { queryClient } from '@/shared/lib/query-client'

export function RenameGlobalPcSet({
	children,
	globalPcSet,
}: {
	globalPcSet: EnrichedGlobalPcSet
	children: React.ReactNode
}) {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const updateGlobalPcSetMutation = useUpdateGlobalPcSetMutation(
		globalPcSet.id,
		{
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: ['global-pc-sets-list'],
				})
			},
		}
	)
	const updateGlobalPcSet = (name: string) => {
		ampli.globalPcSetActionClicked({
			global_pc_set_action: 'rename',
		})
		toast.promise(updateGlobalPcSetMutation.mutateAsync({ name }), {
			loading: t('global_set.rename.processing.loading', {
				defaultValue: 'Renaming global set...',
			}),
			success: t('global_set.rename.processing.success', {
				defaultValue: 'Global set renamed successfully',
			}),
			error: t('global_set.rename.processing.error', {
				defaultValue: 'Error while renaming global set',
			}),
		})
	}
	const handleShowRenameModal = () =>
		showModal('GENERIC_RENAME_MODAL', {
			title: t('app.edit_global_set_name', {
				defaultValue: 'Edit global set name',
			}),
			value: globalPcSet.name,
			onChange: updateGlobalPcSet,
		})

	return <Slot onClick={handleShowRenameModal}>{children}</Slot>
}
